module.exports = __webpack_public_path__ + "static/media/site.e1ef47de.png";